import {getUser} from "../Utils/Security";
import './Dashboard.css';


function Dashboard() {

    const user = getUser();

    return (
        <div className="text-center">
            <h2>Hello {user.firstName}!</h2>
            <p>Welcome to the levitate project! You can upload your excel files and save the data!</p>
        </div>

    );
}

export default Dashboard;